import { render, staticRenderFns } from "./rightHome.vue?vue&type=template&id=3db77778&"
import script from "./rightHome.vue?vue&type=script&lang=js&"
export * from "./rightHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports